module.exports = __webpack_public_path__ + "static/media/newsletter-november-2024-3.4ae33b77.jpg";